import PropTypes from 'prop-types';
import React, { memo, useState } from 'react';
import { useAppContext } from '../../../contexts/AppProvider';
import { classNames } from '../../../utils/classnames';
import { LoadingIcon } from '../../common/LoadingIcon';
import { CartModal } from '../../product/cart-modal';
import { usePageContext } from '../../../contexts/PageProvider';
import { useScreen } from '../../../hooks/useScreen';

/**
 * @description Render memoized button component
 * @param {Object} props
 * @returns {JSX.Element} Memoized button component
 */
export const AddToCartButton = memo(function MemoizedAddToCartButton(props) {
  const [showCartModal, setShowCartModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isMobile } = useScreen();
  const { setShowCartDropdown } = usePageContext();
  const { className, children, variant, options, quantity = 1, disabled = false, isCompleteTheLookSection } = props;
  // Translations
  const addingToCartText = isCompleteTheLookSection ? '' : 'Adding to cart...';

  const appContext = useAppContext();
  const addToCart =
    appContext &&
    Object.prototype.toString.call(appContext) === '[object Object]' &&
    Object.keys(appContext)?.length > 0
      ? appContext.addToCart
      : null;
  const cartData =
    appContext &&
    Object.prototype.toString.call(appContext) === '[object Object]' &&
    Object.keys(appContext)?.length > 0
      ? appContext.cartData
      : null;
  const addingToCart =
    cartData && Object.prototype.toString.call(cartData) === '[object Object]' && Object.keys(cartData)?.length > 0
      ? cartData.addingToCart
      : null;

  const addToBag = async () => {
    setLoading(true);
    var line_item = {
      quantity: quantity,
      product_id: variant?.product_id
    };

    line_item = {
      ...line_item,
      variant_id: variant.id
    };
    const result = await addToCart(line_item);
    setLoading(false);
    // return result ? setShowCartModal(true) : null;
    return result ? (isMobile ? setShowCartModal(true) : setShowCartDropdown(true)) : null;
  };
  return (
    <>
      <button
        disabled={disabled || addingToCart === variant?.product_id}
        onClick={addToBag}
        className={classNames(
          className,
          'px-2',
          (disabled || addingToCart === variant?.product_id) &&
            'cursor-not-allowed disabled:border-transparent disabled:bg-[#969696]'
        )}
      >
        {loading && <LoadingIcon isCompleteTheLookSection={isCompleteTheLookSection} />}
        {variant !== null && addingToCart === variant?.product_id ? addingToCartText : children}
      </button>

      <CartModal open={showCartModal} closeModal={() => setShowCartModal(false)} />
    </>
  );
});

AddToCartButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  options: PropTypes.any,
  quantity: PropTypes.number,
  variant: PropTypes.shape({
    id: PropTypes.any,
    inventory_level: PropTypes.number,
    product_id: PropTypes.any,
    purchasing_disabled: PropTypes.bool
  })
};
